import { useNavigate, useParams } from 'react-router-dom';
import * as React from 'react';
import { Box, Button } from '@mui/material';
import { useState } from 'react';

import { AppContainer } from 'components/common/appContainer';
import { useRisk } from 'hooks/useRisk';
import { ViewRiskComponent } from 'components/common/ViewRiskComponent';
import { UILoader } from 'components/UI/UILoader';
import { Routes } from 'navigation/routes';
import { risksService } from 'core/services/risksService';
import { useAppStore } from 'core/store/app/useAppStore';
import { userRolesPermissions } from 'core/constants/userRolesPermissions';
import { UserRightsContainer } from 'components/common/UserRightsContainer';
import { TaskDeadlineModal } from 'components/common/TaskDeadlineModal/TaskDeadlineModal';
import { RiskAssessmentInfo } from '../components/RiskAssessmentInfo';
import { tasksService } from '../../../core/services/tasksService';

const CheckRiskAssessment = () => {
    const navigate = useNavigate();
    const { riskId } = useParams();

    const { risk } = useRisk(riskId);
    const { setErrorAlertText, setSuccessAlertText } = useAppStore((state) => state);
    const [deadlineModalVisible, setDeadlineRejectModalVisible] = useState<boolean>(false);

    const onSendForRevision = () => {
        navigate(`${Routes.SendForRevisionByCoordinator}/${riskId as string}`);
    };

    const onApprove = (dueDate: string) => {
        if (!riskId) return;

        risksService.approveByCoordinator(
            riskId,
            (res: { data: { taskId: number } }) => {
                const { taskId } = res.data;
                tasksService.setDueDate(dueDate, taskId, () => {
                    setSuccessAlertText('Оценка риска успешно утверждена');
                    navigate(-1);
                });
            },
            () => {
                setErrorAlertText('Ошибка при утверждении оценки риска');
            },
        );
    };

    return (
        <AppContainer>
            <UserRightsContainer allowedUserRoles={userRolesPermissions.risks.checkRiskAssessment}>
                <div className={'container_thin'}>
                    <h2>Оценка риска</h2>
                    {risk ? (
                        <>
                            <ViewRiskComponent risk={risk} />
                            <h3>Оценка</h3>
                            <RiskAssessmentInfo risk={risk} />
                            <Box sx={{ display: 'flex', marginBottom: 4 }}>
                                <Box mr={'10px'}>
                                    <Button variant="contained" onClick={() => setDeadlineRejectModalVisible(true)}>
                                        Утвердить оценку риска
                                    </Button>
                                </Box>
                                <Box mr={'10px'}>
                                    <Button variant="outlined" onClick={onSendForRevision}>
                                        Вернуть на доработку
                                    </Button>
                                </Box>
                                <Box mr={'10px'}>
                                    <Button variant="outlined" onClick={() => navigate(-1)}>
                                        Назад
                                    </Button>
                                </Box>
                            </Box>
                            <TaskDeadlineModal
                                isVisible={deadlineModalVisible}
                                setIsVisible={setDeadlineRejectModalVisible}
                                onSuccess={onApprove}
                            />
                        </>
                    ) : (
                        <UILoader isVisible />
                    )}
                </div>
            </UserRightsContainer>
        </AppContainer>
    );
};

export { CheckRiskAssessment };
